import Questionaire from "../components/categoryoptions/questionaire";
import AddNewQuestionaire from "../components/categoryoptions/addnewquestionaire";
import EditQuestion from "../components/categoryoptions/editquestion";
import ViewReports from "../components/categoryoptions/viewreports";
import { useApi } from "../api/useApi";
import { useState, useEffect } from "react";
import { Category } from "@mui/icons-material";

export function useUiConfig() {
  const { request } = useApi();
  const [config, setConfig] = useState({});

  useEffect(() => {
    (async () => {
      const data = await request({ url: '/domains-with-categories' });
      console.log('ui config data', data);
      //const base = { Questionaire, AddNewQuestionaire, EditQuestion, ViewReports };
      const base = { Questionaire: true, Category: true};
      const result = {};
      data.forEach((d) => {
        result[d.name.toLowerCase()] = {
          ...base,
          categories: d.categories
        };
      });
      setConfig(result);
    })();
  }, []);

  return config; // ✅ Hook returning an object
}


